<template>
  <div class="add-memory-dialog" v-if="isAddMemoryShow">
    <div class="title">
      <span>{{ saveMemoryType === 0 ? '保存至记忆库' : '提示' }}</span>
      <i class="close-btn" @click="cancel"></i>
    </div>
    <div class="container" v-show="saveMemoryType === 0">
      <el-form ref="form" :model="form" label-width="54px" :rules="rule">
        <el-form-item label="库名称" prop="name">
          <el-input placeholder="请输入记忆库名称" maxlength="16" v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item label="领域" prop="domainCode">
          <el-select v-model="form.domainCode" placeholder="请选择领域">
            <el-option v-for="(item, index) in optionList" :key="index" :label="item.dataDesc"
                       :value="item.dataKey"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="container success-save" v-show="saveMemoryType === 1">
      <img :src="require('@/assets/imgs/alignment-icons/pic-preservation.png')" alt="" />
      <p>成功保存至记忆库</p>
    </div>
    <div class="btns">
      <el-button :class="saveMemoryType === 1 ? 'toAlignment' : ''" @click="cancel">
        {{ saveMemoryType === 0 ? '取 消' : '继续对齐' }}
      </el-button>
      <el-button type="primary" @click="saveMemory" :class="saveMemoryType === 1 ? 'toMemory' : ''">
        {{ saveMemoryType === 0 ? '保 存' : '管理记忆库' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import bilingualAlignmentAjax from "@/services/bilingualAlignment"
export default {
  name: 'addMemory',
  props: ['isAddMemoryShow', 'saveMemoryType'],
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('记忆库名称不能为空'))
      } else {
        callback()
      }
    }
    const validateDomain = (rule, value, callback) => {
      if (!value) {
        callback(new Error('领域不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        name: '',
        domainCode: '',
        domainName: '',
      },
      optionList: [], //领域
      fileList: [], //文件列表
      rule: {
        name: [{ validator: validateName, trigger: 'blur' }],
        domainCode: [{ validator: validateDomain, trigger: 'blur' }],
      },
    }
  },
  computed: {
    userInfo() {
      const userInfo = this.$store.getters.userInfo
      return userInfo
    }
  },
  mounted() {

  },
  watch: {
    '$store.getters.userInfo': {
      handler(data) {
        if (data) {
          if (Object.keys(data).length) {
            this.getDomainList()
          }
        }
      },
      immediate: true,
    },
    isAddMemoryShow: {
      handler(data) {
        if (data) {
          this.getDomainList();
        }
        // if (!data) {
        //   this.domainCode = this.optionList[0].dataKey
        // }
      },
      // immediate: false,
    },
  },
  methods: {
    //取消 关闭
    cancel() {
      this.form.name = ''
      this.form.domainCode = ''
      this.form.domainName = ''
      this.$refs.form.resetFields()
      this.$emit('cancelAddMemory',this.saveMemoryType)
    },
    //保存记忆库
    saveMemory() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.optionList.forEach((item) => {
            if (this.form.domainCode === item.dataKey) {
              this.form.domainName = item.dataDesc
            }
          })
          let params = JSON.parse(JSON.stringify(this.form))
          this.$emit('memoryApi', params)
        } else {
          return false
        }
      })
    },
    //获取领域列表
    async getDomainList() {
      let params = {
        dataType: "trans_domain",
      }
      const { result, success } = await bilingualAlignmentAjax.getTerritory(params)
      if (!success) {
        return
      }
      this.optionList = result
      this.form.domainCode = result[0].dataKey
      this.form.domainName = result[0].dataDesc
    },

  },
}
</script>

<style scoped lang="scss">
.add-memory-dialog {
  width: 360px;
  background: #ffffff;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;

  .title {
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    color: #333333;
    font-size: 16px;
    padding: 25px 30px 0 30px;
    height: 15px;

    span::before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      width: 3px;
      height: 16px;
      background: linear-gradient(0deg, #99c1ff, #3684ff);
      border-radius: 1px;
      margin-right: 7px;
    }

    .close-btn {
      cursor: pointer;
      display: block;
      width: 15px;
      height: 15px;
      background: url("~@/assets/imgs/alignment-icons/button-cancel.png")
        no-repeat center;
    }
  }

  .container {
    padding: 28px 53px;
    .el-form-item {
      margin-bottom: 20px;

      /deep/ .el-input {
        height: 36px !important;

        .el-input__suffix-inner {
          display: flex;
        }

        .el-input__inner {
          width: 100%;
          height: 36px !important;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-form {
      margin-top: 15px;
    }
    /deep/ .el-form-item__label {
      text-align-last: justify;
      text-align: justify;
      text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
    }
  }

  .success-save {
    padding-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btns {
    padding-bottom: 30px;
    display: flex;
    justify-content: center;
    .el-button + .el-button {
      margin-left: 20px;
    }
    .el-button {
      padding: 0;
      width: 76px;
      height: 30px;
      border-radius: 4px;
      color: #ffffff;
      &:first-child {
        border: 1px solid #0078fc;
        color: #0078fc;
      }
    }

    .toAlignment,
    .toMemory {
      width: 86px;
    }
  }
}
</style>
